import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Main from "./routes/Main";
import Admin from "./routes/Admin";
import Signup from "./routes/Signup";

import { getUser } from "./utils/firebaseUtils";

function App() {
  const [user, setUser] = useState<any>({});

  useEffect(() => {
    const id = localStorage.getItem("id");
    if (id !== null) {
      getUser(id).then((returnedUser) => setUser(returnedUser));
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main user={user} setUser={setUser} />} />
        <Route path="signup" element={<Signup user={user} setUser={setUser} />} />
        <Route path="admin" element={<Admin user={user} setUser={setUser} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
